// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__hEijb","emails":"CreateEditClinics_emails__3Z0g9","emailTagLabel":"CreateEditClinics_emailTagLabel__2xzs8"};